// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"c284001c","605":"786ec425","967":"ea37c064"}[chunkId] + ".chunk.js";
};